module.exports = __webpack_public_path__ + "img/ditan_xc7.38fe3fc7.jpg";